(() => {
  const SORT_VALUE = 'pictures_first';
  const REVIEW_BODY_SELECTOR = '.jdgm-review-content__body-content';
  const SORT_SELECTOR = 'select.jdgm-sort-dropdown';

  const normalize = (value) => value.replace(/\s+/g, ' ').trim();

  const createTranslationNote = (root, body, original, entry) => {
    const note = document.createElement('div');
    note.className = 'buggino-review-translation';

    const label = document.createElement('span');
    label.className = 'buggino-review-translation__label';
    label.textContent =
      entry.action === 'smoothed'
        ? root.dataset.reviewSmoothedLabel
        : root.dataset.reviewTranslatedLabel;

    const toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'buggino-review-translation__toggle';
    toggle.textContent = root.dataset.reviewOriginalLabel;
    toggle.setAttribute('aria-pressed', 'false');

    let showingOriginal = false;
    toggle.addEventListener('click', () => {
      showingOriginal = !showingOriginal;
      body.textContent = showingOriginal ? original : entry.text;
      toggle.textContent = showingOriginal
        ? root.dataset.reviewTranslationLabel
        : root.dataset.reviewOriginalLabel;
      toggle.setAttribute('aria-pressed', String(showingOriginal));
    });

    note.append(label, toggle);
    return note;
  };

  const localizeVisibleReviews = (root, translations) => {
    root.querySelectorAll(REVIEW_BODY_SELECTOR).forEach((body) => {
      if (body.dataset.bugginoLocalized === 'true') return;

      const original = normalize(body.textContent || '');
      const entry = translations[original];
      body.dataset.bugginoLocalized = 'true';
      if (!entry || !entry.text || entry.text === original) return;

      body.textContent = entry.text;
      const wrapper = body.closest('.jm-review-body-wrapper') || body.parentElement;
      if (wrapper && !wrapper.querySelector('.buggino-review-translation')) {
        wrapper.append(createTranslationNote(root, body, original, entry));
      }
    });
  };

  const initialize = async () => {
    const root = document.querySelector('#judgeme_product_reviews');
    if (!root) return;

    let initialSortApplied = false;
    let translations = {};
    const isGerman = document.documentElement.lang.toLowerCase().startsWith('de');

    if (isGerman && root.dataset.reviewTranslationsUrl) {
      try {
        const response = await fetch(root.dataset.reviewTranslationsUrl, {
          credentials: 'same-origin',
        });
        if (response.ok) translations = await response.json();
      } catch (_error) {
        translations = {};
      }
    }

    const firstReviewHasMedia = () => {
      const firstReview = root.querySelector('.jm-review-item');
      return Boolean(firstReview?.querySelector('img, video'));
    };

    const applyPictureSort = () => {
      const sort = root.querySelector(SORT_SELECTOR);
      const hasPictureSort = sort
        ? Array.from(sort.options).some((option) => option.value === SORT_VALUE)
        : false;
      if (!sort || !hasPictureSort) return;

      const nativeValueSetter = Object.getOwnPropertyDescriptor(
        HTMLSelectElement.prototype,
        'value'
      )?.set;
      if (nativeValueSetter) nativeValueSetter.call(sort, SORT_VALUE);
      else sort.value = SORT_VALUE;
      sort.dispatchEvent(new Event('input', { bubbles: true }));
      sort.dispatchEvent(new Event('change', { bubbles: true }));
    };

    const enhance = () => {
      if (!initialSortApplied) {
        const sort = root.querySelector(SORT_SELECTOR);
        const hasPictureSort = sort
          ? Array.from(sort.options).some((option) => option.value === SORT_VALUE)
          : false;
        if (sort && hasPictureSort) {
          initialSortApplied = true;
          window.setTimeout(applyPictureSort, 150);
          window.setTimeout(() => {
            if (!firstReviewHasMedia()) applyPictureSort();
          }, 900);
        }
      }

      if (isGerman) localizeVisibleReviews(root, translations);
    };

    const observer = new MutationObserver(enhance);
    observer.observe(root, { childList: true, subtree: true });
    enhance();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
